enum ContractType {
  PPA = 'Third Party Owned - PPA',
  Lease = 'Third Party Owned - Lease',
  PPA_Lease = 'Third Party Owned - PPA + Lease',
  EPC = 'Landlord or Tenant Owned - EPC',
}

export default ContractType;
